// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddProdCat_importCsvCard__EML9O","addProdCatBtnContainer":"AddProdCat_addProdCatBtnContainer__Vvr4X"};